import type { ReactNode } from 'react'
import './auth.css'

/** Entry screens: the key art behind one framed wooden panel. */
export function AuthFrame({ title, sub, children, wide, className = '' }: { title: string; sub?: string; children: ReactNode; wide?: boolean | 'creation'; className?: string }) {
  return (
    <div className={`g3 auth ${className}`}>
      <picture className="auth__bg" aria-hidden="true">
        <source media="(max-width: 599px)" srcSet="/assets/ui/backdrop-narrow.webp" />
        <img src="/assets/ui/backdrop-wide.webp" alt="" />
      </picture>
      <main className={wide === 'creation' ? 'auth__panel auth__panel--creation iron wood' : wide ? 'auth__panel auth__panel--wide iron wood' : 'auth__panel iron wood'}>
        <header className="auth__head">
          <img src="/assets/brand/mark.webp" alt="" width={40} height={40} />
          <div>
            <h1>{title}</h1>
            {sub && <p>{sub}</p>}
          </div>
        </header>
        {children}
      </main>
    </div>
  )
}

type FieldProps = {
  id: string
  label: string
  value: string
  onChange: (v: string) => void
  type?: 'text' | 'password'
  autoComplete?: string
  error?: string | null
  hint?: string
  maxLength?: number
  autoFocus?: boolean
}

/** A labelled input on an iron slab; the error is read out with the field. */
export function Field({ id, label, value, onChange, type = 'text', autoComplete, error, hint, maxLength, autoFocus }: FieldProps) {
  const described = [error ? `${id}-error` : null, hint ? `${id}-hint` : null].filter(Boolean).join(' ') || undefined
  return (
    <div className={error ? 'field is-error' : 'field'}>
      <label htmlFor={id}>{label}</label>
      <input id={id} className="slab" type={type} value={value} onChange={e => onChange(e.target.value)} autoComplete={autoComplete}
        aria-invalid={error ? true : undefined} aria-describedby={described} maxLength={maxLength} autoFocus={autoFocus} spellCheck={false} />
      {hint && <small id={`${id}-hint`}>{hint}</small>}
      {error && <small className="field__error" id={`${id}-error`}>{error}</small>}
    </div>
  )
}

/** Form-level message (server refusal, network). */
export function FormError({ text }: { text: string | null }) {
  return <p className="auth__error" role="alert">{text ?? ''}</p>
}
